import { placementRepository } from '~/api/repository/placement';

export const PLACEMENT_QUERY_KEY = {
  all: ['placement'] as const,

  // GNB 네비게이션 바 조회
  navigationBars: (businessId: number) => ({
    queryKey: [
      '/api/market-place/v1/placements/navigation-bars-new',
      businessId,
    ] as const,
    queryFn: () => placementRepository.getNavigationBars(businessId),
  }),

  // 지면 배너 조회
  banners: (businessId: number, placement: string) => ({
    queryKey: [
      '/api/market-place/v1/placements/banners',
      businessId,
      placement,
    ] as const,
    queryFn: () => placementRepository.getBanners(businessId, placement),
  }),

  // 검색 추천 키워드(광고) 조회
  searchKeywords: (businessId: number, placement: string) => ({
    queryKey: [
      '/api/market-place/v1/placements/search-keywords',
      businessId,
      placement,
    ] as const,
    queryFn: () => placementRepository.getSearchKeywords(businessId, placement),
  }),

  // 검색 상단 배너 조회
  searchTopBanners: (businessId: number) => ({
    queryKey: [
      '/api/market-place/v1/placements/search-top-banners',
      businessId,
    ] as const,
    queryFn: () => placementRepository.getSearchTopBanners(businessId),
  }),
};
